import React, { useMemo } from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import TextField from "@mui/material/TextField"

const MCP_BRIDGE_PACKAGE = "@myneurogym/mcp-claude-bridge@latest"

const McpCloudConfigDialog = ({ open, cloudConfig, onClose, title }) => {
  const configText = useMemo(() => {
    if (!cloudConfig?.email) return ""
    const apiUrl = cloudConfig.apiUrl || "https://stage.api.myinnercise.com"
    const template = {
      mcpServers: {
        "neurogym-cms": {
          command: "npx",
          args: ["-y", MCP_BRIDGE_PACKAGE],
          env: {
            NEUROGYM_MCP_URL: apiUrl,
            NEUROGYM_MCP_EMAIL: cloudConfig.email,
            NEUROGYM_MCP_PASSWORD:
              cloudConfig.password || "<password-from-create-or-reset>",
          },
        },
      },
    }
    return JSON.stringify(template, null, 2)
  }, [cloudConfig])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(configText)
    } catch (error) {
      console.error("Failed to copy cloud config:", error)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title || "MCP Cloud Config"}</DialogTitle>
      <DialogContent>
        <p style={{ marginTop: 0, color: "var(--cms-text-secondary, #64748b)", fontSize: 14 }}>
          Add this to Claude Desktop <code>claude_desktop_config.json</code> (requires Node.js 18+). Same config for every user — only credentials differ. For local API, set <code>NEUROGYM_MCP_URL</code> to <code>http://localhost:3000</code>.
        </p>
        <TextField
          fullWidth
          multiline
          minRows={12}
          value={configText}
          InputProps={{ readOnly: true }}
          variant="outlined"
          size="small"
          sx={{ fontFamily: "monospace", mt: 1 }}
        />
        {!cloudConfig?.password ? (
          <p style={{ fontSize: 13, color: "var(--cms-text-secondary, #64748b)" }}>
            Password is only shown when a user is created or reset. Use Reset Password to generate a new one.
          </p>
        ) : (
          <p style={{ fontSize: 13, color: "var(--cms-warning, #d97706)", marginTop: 12 }}>
            Copy this config now — the new password replaces the old one immediately and will not be shown again.
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCopy} disabled={!configText}>
          Copy
        </Button>
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default McpCloudConfigDialog
